"use client";

import { forwardRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { sans } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const Button = styled.button.withConfig({
  componentId: "sc-1v62o0r-0"
})(["background:0;border:0;padding:0;margin:0;text-align:inherit;cursor:pointer;color:inherit;font-family:", ";text-decoration:none;&[disabled]{cursor:not-allowed;}"], sans);

/**
 * Use when a button is needed for accessibility purposes but no button styles are desired.
 */
const A11y = /*#__PURE__*/forwardRef(({
  href,
  disabled,
  renderAs = href && !disabled ? "a" : "button",
  type = renderAs === "button" ? "button" : undefined,
  ...props
}, ref) => /*#__PURE__*/_jsx(Button, {
  ...props,
  ref: ref,
  type: type,
  href: href,
  disabled: disabled,
  as: renderAs,
  children: props.children
}));
A11y.displayName = "A11y";
A11y.propTypes = {
  /** The button contents */
  children: PropTypes.node.isRequired,
  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes) or the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes). */
  type: PropTypes.string,
  /** If the button should be disabled */
  disabled: PropTypes.bool,
  /** The link that the button should navigate to on click */
  href: PropTypes.any,
  /** The HTML tag string or React component to render as.
   *
   * By default, if `href` is present and it is not `disabled`, it will render as an `<a>`. Otherwise it will default to `<button>`. */
  renderAs: PropTypes.elementType
};
export default A11y;